import { render, staticRenderFns } from "./SettingsPrivacy.vue?vue&type=template&id=2e621146&scoped=true"
import script from "./SettingsPrivacy.vue?vue&type=script&lang=ts&setup=true"
export * from "./SettingsPrivacy.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./SettingsPrivacy.vue?vue&type=style&index=0&id=2e621146&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e621146",
  null
  
)

export default component.exports